import common_reducers from "../../common/redux/reducers";
import { combineReducers } from "redux";

import { mdmReducer } from "./mdmReducer";
import { counterStatesReducer } from "./counterStatesReducer";
import { userCompanyReducer } from "./userCompanyReducer";
import { agreementReducer } from "./agreementReducer";
import { profilesReducer } from "./profilesReducer";
import { profilesExportReducer } from "./profilesExportReducer";
import { agreementPermissionReducer } from "./agreementPermissionReducer";

export default combineReducers({
    ...common_reducers,
    mdmReducer,
    counterStatesReducer,
    userCompanyReducer,
    agreementReducer,
    profilesReducer,
    profilesExportReducer,
    agreementPermissionReducer
});
